import {CompanyEntity} from "@ots-frontend/ots-data";
import {Card, Divider, Grid, Group, Text, Title} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {ObjectMappingDataTableCard} from "../../card/ObjectMappingDataTableCard/ObjectMappingDataTableCard";
import {HasAccess} from "../../auth/HasAccess/HasAccess";
import {RrcCompanyProfileDataTableCard} from "../../card/RrcCompanyProfileDataTableCard/RrcCompanyProfileDataTableCard";
import { useApp } from "../../../providers/RegionProvider/RegionProvider";
import {
  RrcLocationProfileDataTableCard
} from "../../card/RrcLocationProfileDataTableCard/RrcLocationProfileDataTableCard";
import {
  RrcEp9WasteProfileDataTableCard
} from "../../card/RrcEp9WasteProfileDataTableCard/RrcEp9WasteProfileDataTableCard";

export type CompanyDetailsProps = {
  company: CompanyEntity
}

export const CompanyDetails = (props: CompanyDetailsProps) => {
  const {company} = props;

  const {compliance} = useApp()
  const {t} = useTranslation(["common"]);

  return (
    <Grid>
      <Grid.Col span={6}>
        <Card shadow="sm" padding="lg" radius="md" withBorder>

          <Group position="apart" pb="sm">
            <Title order={4}>{t("profile.company.info.section.details.label", "Details")}</Title>
          </Group>

          <Divider/>

          <Grid>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.company.info.field.name.label", "Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {company.name}
              </Text>
            </Grid.Col>
          </Grid>
        </Card>
      </Grid.Col>
      <Grid.Col span={6}>
        <HasAccess permissions={["object_mapping_view"]}>
          <ObjectMappingDataTableCard entity={company}/>
        </HasAccess>
      </Grid.Col>

      {compliance?.rrc === true &&
        <>
          <HasAccess permissions={["rrccompanyprofile_view"]}>
            <Grid.Col span={12}>
              <RrcCompanyProfileDataTableCard company={company}/>
            </Grid.Col>
          </HasAccess>
          <HasAccess permissions={["rrcep9wasteprofile_view"]}>
            <Grid.Col span={12}>
              <RrcEp9WasteProfileDataTableCard entity={company}/>
            </Grid.Col>
          </HasAccess>
        </>

      }
    </Grid>
  );
};

